import { RootContainer } from '../../../../core/root_container';
import { KeywordJsEnv } from '../../models/keyword_js_env';
import { RrBodyKeywordLeftSide } from './rr_body';

export class KeywordRrSideContainer extends RootContainer<KeywordJsEnv> {
  constructor(model: KeywordJsEnv) {
    super();

    this.mount(RrBodyKeywordLeftSide, model.rrAreaProfileKeywordLeftSide.placementName);

    // 描画
    this.update(model);

    const WindowCarousel = window._carousel;
    new WindowCarousel( // NOSONAR
      `#${model.rrAreaProfileKeywordLeftSide.placementName}`);
  }
}
